import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from './styles'

const MobileLink = ({ children, isMenu, isSubLink, toggleNavbar, ...props }) => {
  let classes = { className: styles.link, activeClassName: styles.activeLink }

  if (isMenu) classes = { className: styles.link, activeClassName: styles.activeSubNav }
  else if (isSubLink)
    classes = {
      className: styles.subLink,
      activeClassName: styles.activeSubLink,
    }

  return (
    <NavLink {...props} onClick={toggleNavbar} {...classes}>
      {children}
    </NavLink>
  )
}

export default MobileLink
